import type { NodeOperation, RegisteredNodeOperation } from './types';

export function defineNavigationPanelNodeOperations<TId extends string>(
  operations: readonly RegisteredNodeOperation<TId>[]
): NodeOperation[] {
  return [...operations];
}

export function resolveNavigationPanelNodeOperations(
  ...sources: readonly (readonly NodeOperation[] | undefined)[]
) {
  const operations = sources
    .flatMap(source => source ?? [])
    .map((operation, sourceOrder) => ({ operation, sourceOrder }))
    .sort(
      (a, b) =>
        a.operation.index - b.operation.index || a.sourceOrder - b.sourceOrder
    )
    .map(({ operation }) => operation);
  const menuOperations = operations.filter(operation => !operation.inline);

  return {
    inlineOperations: operations.filter(operation => operation.inline),
    // One resolved policy list feeds both the click overflow and context menu.
    menuOperations,
    contextMenuOperations: menuOperations,
  };
}
